// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.qualification .sk-select__list-item.is-marked {\n  font-weight: normal;\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
